<template>
    <b-card no-body>
        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <street-create-or-update v-model="street" :errors="errors"></street-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table
            ref="table"
            :items-provider="provider"
            :fields="fields"
            :add-callback="createNew"
            :buttons="buttons"
            search
            pagination="server">
        </v-table>
    </b-card>
</template>

<script>
    import { BCard } from 'bootstrap-vue';
    import SystemDataApi from '@/api/system-data';
    import StreetCreateOrUpdate from './components/StreetCreateOrUpdate.vue';

    export default {
        components : {
            BCard,
            StreetCreateOrUpdate
        },
        data() {
            return {
                fields:[
                    {name:'Ülke', key: 'CountryName', thClass: 'w-20'},
                    {name: 'İl', key: 'ProvinceName', thClass: 'w-20'},
                    {name: 'İlçe',key: 'DistrictName',thClass: 'w-20'},
                    {name: 'Mahalle', key: 'NeighborhoodName', thClass: 'w-20'},
                    {name: 'Sokak',key:'Name',thClass:'w-20'}
                ],
                buttons : [
                    { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                    { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                ],
                street: {
                    Name : null,
                    Id : null,
                    CountryId : null,
                    CountryName : null,
                    ProvinceId : null,
                    ProvinceName: null,
                    DistrictId : null,
                    NeighborhoodId : null
                    
                },
                errors:{},
                    editing: false,
                    loading: false
            }
        },
        methods: {
            provider(data) {
                return SystemDataApi.StreetOperations.Table(data)
            },
            clearForm(){
                this.editing = false
                this.street.Id = null
                this.street.Name = null
                this.street.CountryId = null
                this.street.CountryName = null
                this.street.ProvinceId = null
                this.street.ProvinceName = null
                this.street.DistrictId = null
                this.street.NeighborhoodId = null
            },
            createNew(){
                this.clearForm()
                this.$showModal('create-or-update')
            },
            edit(item){
                this.clearForm()
                this.editing = true
                this.street.Id = item.Id
                this.street.Name = item.Name
                this.street.CountryId = item.CountryId
                this.street.CountryName = item.CountryName
                this.street.DistrictId = item.DistrictId
                this.street.ProvinceId = item.ProvinceId
                this.street.ProvinceName = item.ProvinceName
                this.street.NeighborhoodId = item.NeighborhoodId
                this.$showModal('create-or-update')
            },
            createOrUpdate(){
                this.loading = true
                SystemDataApi.StreetOperations.CreateOrUpdate(this.editing,this.street)
                .then(res=>{
                    if(res.data.Success) {
                        this.$refs.table.refresh()
                        this.$hideModal('create-or-update')
                    }
                    this.$result(res)
                    this.loading = false
                })
                .catch(err=>{
                    this.$result(null,err)
                    this.loading = false
                })
            },
            delete(item){
                this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli sokak bilgisini silecektir ve geri alınamaz.`).then(result=>{
                    if(result){
                        SystemDataApi.StreetOperations.Delete(item.Id).then(res=>{
                            if(res.data.Success) {
                                this.$refs.table.refresh()
                            }
                            this.$result(res)
                        }).catch(err=>{
                            this.$result(null,err)
                        })
                    }
                })
            }
        }
    }
</script>